module.exports = __webpack_public_path__ + "img/9788937834349.a46b5bd4.jpg";